import React from 'react';
import { Link, Outlet } from "react-router-dom";
// import './login.css';
// import { Button } from "../../components/button/Button"

export const Switcher: React.FC = () => {
  return (
    <div>		
    <ul className="login-switcher">
        <li>
            <Link to={`sign-in`}>Aanmelden</Link>
        </li>
        <li>
            <Link to={`sign-up`}>Nieuwe account</Link>
        </li>
    </ul>
    <Outlet/>
        {/* <Link to={`reset-password`}>Perongeluk wachtwoord vergeten?</Link>	 */}
    </div>
)}